import { render } from "./Z04RecommendMenu.vue?vue&type=template&id=52092bea&scoped=true&ts=true"
import script from "./Z04RecommendMenu.vue?vue&type=script&lang=ts"
export * from "./Z04RecommendMenu.vue?vue&type=script&lang=ts"

import "./Z04RecommendMenu.vue?vue&type=style&index=0&id=52092bea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52092bea"]])

export default __exports__